<template>
  <mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load" />
  <div class="goods-diy-wrap" v-else>
    <div class="image">
      <div class="img-box" v-for="(item,index) in diyImages" :style="{'z-index':item.imageIndex}">
        <!-- <imgs :imagePath="item.sku && item.sku.diyImage && item.sku.diyImage.imagePath"></imgs> -->
        <img :src="imagePath(item.sku && item.sku.diyImage && item.sku.diyImage.imagePath)" alt="">
      </div>
    </div>
    <!-- 已选类型展示 -->
    <div class="select-type">
      <div class="typeItem" v-for="item in selectDIYinfo">
        <label>{{item.fieldName}}：</label>
        <span>{{item.valueName}}</span>
      </div>
    </div>
    <!-- 类型选择 -->
    <ul class="mx-mall-type">
      <template v-for="diyProperty,index in (diyPropertys && diyPropertys.items)">
        <li class="type-list" :class="{active:typeId==i+'field'}" v-for="(item,i) in (diyProperty.itemInfo&&diyProperty.itemInfo.fields)">
          <template v-if="diyProperty.itemType==1">
            <div class="head" @click="typeId=i+'field'">{{item.fieldName}}</div>
            <div class="type-box">
              <div class="img-box" v-for="info in item.values" :class="{active:info.isChecked==1}" @click="selectDiyGood(index,diyProperty.goodsId,item.fieldId,info.valueId,diyProperty.imageIndex)">
                <imgs v-if="info.imagePath" :imagePath="info.imagePath && info.imagePath.imagePath"></imgs>
                <b>{{info.valueName}}</b>
              </div>
            </div>
          </template>
        </li>
        <li class="type-list" :class="{active:typeId==index}">
          <template v-if="diyProperty.itemType==2">
            <div class="head" @click="typeId=index">{{diyProperty.itemName}}</div>
            <div class="type-box">
              <div class="img-box" v-for="info in diyProperty.itemInfo" :class="{active:info.isChecked==1}" @click="selectDiyProperty(index,info.skuId)">
                <imgs :imagePath="info.diyImage && info.diyImage.imagePath"></imgs>
              </div>
            </div>
          </template>
        </li>
      </template>
    </ul>
    <!-- 选择数量 -->
    <div class="number-box">
      <div class="floatL">数量</div>
      <div class="floatR">
        <div class="goods-number">
          <span class="add-btn" @click="changegoodsNum('reduce')"></span>
          <input v-model="goodsNum" readonly />
          <span class="reduce-btn" @click="changegoodsNum('add')"></span>
          <samp>套</samp>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <!-- 单价 -->
    <div class="utilPrice">
      <div class="floatL">
        <label>优惠价</label>
        <span><samp>¥</samp>{{skuInfo && skuInfo.goodsPrice.toFixed(2)}}</span>
      </div>
      <div class="floatR">售价 <span>¥{{skuInfo && skuInfo.unitPrice.toFixed(2)}}</span></div>
      <div class="clearfix"></div>
    </div>
    <!-- 总价 -->
    <div class="totalPrice">
      <div class="floatL">
        <label>总价</label>
        <span><samp>¥</samp>{{totalPrice}}</span>
      </div>
      <div class="floatR">共 <span>{{goodsNum}}</span> 套</div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import imgs from '@components/image/image'
  import { mapActions, mapGetters } from 'vuex'
  import Constant from '@/Constant'
  export default {
    data() {
      return {
        load: true,
        typeId: 0,
        goodsNum: 1, //商品数量
        totalPrice: 0, //商品总价
        goodsId: this.$route.query.goodsId, //商品id
        storeId: this.$route.query.storeId, //商品id
        diyInfos: [], //diy信息列表
        diyPropertys: null, //diy选中属性
        diyImages: [], //选中的内容
        skuInfo: null, //选中属性总的内容
        values: [], //选中的商品sku
        diyId: null, //diyId
        skuIds: [], //选中的单品id
        selectDIYinfo: [] //选中的DIY信息
      }
    },
    watch: {
      diyPropertys() {
        let diyPropertys = []
        if (this.diyPropertys && this.diyPropertys.diyId) {
          diyPropertys = this.diyPropertys.items.filter(item => {
            return item.itemType == 1
          })
        }
        diyPropertys.forEach(item => {
          //默认选中的图片信息
          let image = {
            imageIndex: item.imageIndex,
            sku: item.itemInfo.sku
          }

          item.itemInfo.fields.forEach(field => {
            field.values.forEach(item => {
              //初始化values信息
              let value = {}
              this.values = this.values.filter(it => {
                return item.valueId != it.valueId
              })

              if (item.isChecked == 1) {
                value = {
                  fieldId: item.fieldId,
                  valueId: item.valueId
                }

                this.values.push(value)
              }
            })
          })
          this.getImages(image)
        })
      },
      diyImages() {
        if (this.diyImages && this.diyImages.length) {
          this.skuInfo = {
            goodsPrice: 0,
            unitPrice: 0,
            selectGood: ''
          }
          this.diyImages.forEach(item => {
            this.skuInfo.goodsPrice = Number(this.skuInfo.goodsPrice) + Number(item.sku.goodsPrice)
            this.totalPrice = this.skuInfo.goodsPrice * this.goodsNum
            this.skuInfo.unitPrice += Number(item.sku.unitPrice)
            this.skuInfo.selectGood = this.skuInfo.selectGood
              ? this.skuInfo.selectGood + ',' + item.sku.skuFields
              : item.sku.skuFields
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        diyGoodData: 'diyGoodData' //产品信息
      }),
      currentIndex() {
        return this.$route.meta.id
      }
    },
    methods: {
      ...mapActions({
        getOrderSettleMsgForDiy: 'getOrderSettleMsgForDiy', //直接购买-DIY商品
        getDiyInfo: 'getDiyInfo', //获取商品SKU信息
        getDiySku: 'getDiySku', //通过选择属性 获取 商品单品信息
        saveDiyData: 'saveDiyData' //保存购买的商品信息
      }),

      //保存要购买的商品的信息
      saveDiyForBuy() {
        let skuIds = []
        this.diyImages.forEach(item => {
          if (item.sku.skuId) {
            skuIds.push(item.sku.skuId)
          }
        })
        let _this = this
        this.saveDiyData({
          diyId: _this.diyId,
          skuIds: skuIds,
          goodsNum: _this.goodsNum,
          selectDIYinfo: _this.selectDIYinfo
        })
      },
      //商品加减
      changegoodsNum(action) {
        if (action == 'add') {
          this.goodsNum += 1
        } else if (action == 'reduce') {
          if (this.goodsNum == 1) return
          this.goodsNum -= 1
        }
        this.totalPrice = this.skuInfo.goodsPrice * this.goodsNum
        this.saveDiyForBuy() //将需要购买的商品信息存储
      },
      //图片路径
      imagePath(imagePath) {
        return Constant.imgBaseUrl + '/' + imagePath
      },

      //获取diy信息
      getDiyInfos() {
        this.getDiyInfo([this.storeId, this.goodsId])
          .then(res => {
            console.log('res', res)
            this.diyInfos = res
            this.load = false
            if (res == null) return
            this.diyPropertys = this.diyInfos.find(item => {
              this.diyId = item.diyId
              //筛选选中的各配件信息
              if (item.items[0].itemInfo && item.items[0].itemInfo.fields && item.items[0].itemInfo.fields.length > 0) {
                item.items[0].itemInfo.fields.forEach((sub, index) => {
                  sub.values.find(field => {
                    this.selectDIYinfo = this.selectDIYinfo.filter(t => t.fieldName != field.fieldName)
                    this.selectDIYinfo.push({
                      fieldName: field.fieldName,
                      valueName: field.valueName
                    })
                    return field.isChecked == 1
                  })
                })
              }

              this.saveDiyForBuy() //将需要购买的商品信息存储

              return item.isChecked == 1
            })
          })
          .catch(error => {
            this.$message.error(error)
          })
      },

      //获取diy单品信息
      getDiySkus(goodsId, imageIndex) {
        this.getDiySku([goodsId, this.values]).then(res => {
          this.diyImages.forEach((item, index) => {
            if (imageIndex == item.imageIndex) {
              let image = {
                imageIndex: item.imageIndex,
                sku: res
              }

              this.$set(this.diyImages, index, image)
            }
          })
          this.saveDiyForBuy() //将需要购买的商品信息存储
        })
      },

      //获取组合展示门数据
      getImages(item) {
        if (this.diyImages && this.diyImages.length) {
          this.diyImages = this.diyImages.filter(diy => {
            return diy.imageIndex != item.imageIndex
          })
        }
        this.diyImages.push(item)
      },

      //选择diy单品属性
      selectDiyGood(index, goodsId, fieldId, valueId, imageIndex) {
        let itemInfo = this.diyPropertys.items[index].itemInfo.fields.find(item => {
          return item.fieldId == fieldId
        })

        itemInfo.values.forEach(item => {
          if (item.valueId == valueId) {
            item.isChecked = 1
            let value = {}
            if (this.values && this.values.length) {
              this.values = this.values.filter(it => {
                return it.fieldId != fieldId
              })
            }
            value.valueId = item.valueId
            value.fieldId = item.fieldId
            this.values.push(value)
            this.selectDIYinfo = this.selectDIYinfo.filter(t => t.fieldName != item.fieldName)
            this.selectDIYinfo.push({
              fieldName: item.fieldName,
              valueName: item.valueName
            })
          } else {
            item.isChecked = 0
          }
        })

        //获取diy单品信息
        this.getDiySkus(goodsId, imageIndex)
      },

      //选择diy单品
      selectDiyProperty(index, skuId) {
        let itemInfo = this.diyPropertys.items[index]
        let image = {
          imageIndex: itemInfo.imageIndex
        }
        itemInfo.itemInfo.forEach(item => {
          if (item.skuId == skuId) {
            item.isChecked = 1
            this.selectDIYinfo = this.selectDIYinfo.filter(t => t.fieldName != itemInfo.itemName)
            this.selectDIYinfo.push({
              fieldName: itemInfo.itemName,
              valueName: item.values[0].valueName
            })
            image.sku = item
            this.getImages(image)
          } else {
            item.isChecked = 0
          }
        })
        this.saveDiyForBuy() //将需要购买的商品信息存储
      },

      //diy系列选择
      shooseSeries(id) {
        if (this.diyId == id) {
          return
        }

        this.diyId = id
        this.diyImages = []
        this.values = []
        this.diyInfos.forEach(item => {
          if (item.diyId == id) {
            item.isChecked = 1
          } else {
            item.isChecked = 0
          }
        })

        this.diyPropertys = this.diyInfos.find(item => {
          return item.isChecked == 1
        })
      }
    },
    components: {
      imgs
    },
    created() {
      this.getDiyInfos()
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import 'src/common/sass/mixin.scss';
  .goods-diy-wrap {
    > .image {
      background: #fff;
      height: 6rem;
      position: relative;
      > .img-box {
        width: 6rem;
        height: 6rem;
        margin: 0 auto;
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        img {
          height: 6rem;
        }
      }
    }
    .select-type {
      padding: 0.3rem 0 0.3rem 0.35rem;
      @include font-dpr(12px);
      color: #999999;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      overflow-x: auto;
      background: #ececec;
      .typeItem {
        display: inline-block;
        margin-right: 0.35rem;
        > span {
          color: #e60012;
        }
      }
    }
    .mx-mall-type {
      background: #fff;
      padding-bottom: 0.35rem;
      margin-bottom: 0.2rem;
      .type-list {
        padding-left: 0.35rem;
        .head {
          padding: 0.25rem 0;
          @include font-dpr(12px);
          color: #999999;
        }
        .type-box {
          height: 0;
          white-space: nowrap;
          -webkit-overflow-scrolling: touch;
          overflow-x: auto;
          overflow-y: hidden;
          font-size: 0;
          transition: 0.5s;
          > .img-box {
            display: inline-block;
            width: 1.4rem;
            height: 1.4rem;
            padding: 2px;
            border: 1px solid #d8d8d8;
            margin-right: 0.35rem;
            text-align: center;
            &.active {
              border-color: #e60012;
            }
            > b {
              @include font-dpr(14px);
              line-height: 1.4rem;
            }
          }
        }
        &.active {
          .head {
            font-weight: 700;
            color: #333333;
          }
          .type-box {
            height: 1.4rem;
            transition: 0.5s;
          }
        }
      }
    }
    .number-box {
      background: #fff;
      padding: 0 0.35rem 0;
      .floatL {
        padding: 15px 0;
        @include font-dpr(14px);
        color: #999999;
      }
      .floatR {
        .goods-number {
          padding: 8px 0;
          > input,
          > span {
            display: inline-block;
            height: 0.875rem;
            border: 1px solid #cfcfcf;
            border-radius: 0.1rem;
            vertical-align: middle;
          }
          > span {
            width: 0.875rem;
            &.add-btn {
              background: url(/static/images/detail_product_delete_3x.png) no-repeat center;
              background-size: 0.35rem auto;
            }
            &.reduce-btn {
              background: url(/static/images/detail_product_add_3x.png) no-repeat center;
              background-size: 0.35rem auto;
            }
          }
          > input {
            width: 1.75rem;
            margin: 0 6px;
            text-align: center;
            @include font-dpr(16px);
            color: #000000;
          }
          > samp {
            display: inline-block;
            margin-left: 0.4rem;
            @include font-dpr(14px);
            color: #666666;
            vertical-align: middle;
          }
        }
      }
    }
    .utilPrice {
      margin-top: 1px;
      padding: 0.4rem 0.35rem;
      background: #fff;
      @include font-dpr(14px);
      .floatL {
        color: #999999;
        > span {
          color: #e60012;
          font-weight: 700;
          @include font-dpr(20px);
          > samp {
            padding: 0 0.125rem 0 0.2rem;
            @include font-dpr(13px);
          }
        }
      }
      .floatR {
        line-height: 0.7rem;
        > span {
          position: relative;
          @include line(0, 0, #333333, 1px);
        }
      }
    }
    .totalPrice {
      padding: 0.225rem 0.35rem;
      background: #ffe3e6;
      @include font-dpr(12px);
      color: #999999;
      .floatL {
        > span {
          color: #e60012;
          font-weight: 700;
          > samp {
            padding: 0 0.075rem;
          }
        }
      }
      .floatR {
        > span {
          color: #101010;
          padding: 0 2px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// goodsDiy.vue?2cf44712